import { useState } from 'react';
import { Input } from './ui.jsx';

/** Shared filter sidebar for both directories. Collapses to a sheet on mobile. */
export function FilterPanel({
  children,
  activeCount = 0,
  onClear,
  searchValue,
  onSearch,
  searchPlaceholder = 'Search',
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center justify-between rounded-md border border-rule-strong bg-paper-raised px-3 py-2 text-sm lg:hidden"
        aria-expanded={open}
      >
        <span className="font-medium">Filters{activeCount > 0 && ` (${activeCount})`}</span>
        <svg
          viewBox="0 0 24 24"
          className={`size-4 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          aria-hidden="true"
        >
          <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <aside className={`w-full shrink-0 lg:block lg:w-60 ${open ? 'block' : 'hidden'}`}>
        <div className="space-y-5 lg:sticky lg:top-20">
          {onSearch && (
            <Input
              type="search"
              value={searchValue}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={searchPlaceholder}
              aria-label={searchPlaceholder}
            />
          )}

          {activeCount > 0 && (
            <button
              type="button"
              onClick={onClear}
              className="text-xs font-medium text-accent hover:underline"
            >
              Clear {activeCount} filter{activeCount === 1 ? '' : 's'}
            </button>
          )}

          {children}
        </div>
      </aside>
    </>
  );
}

export function FilterGroup({ label, children }) {
  return (
    <fieldset>
      <legend className="mb-1.5 text-2xs font-semibold uppercase tracking-wider text-ink-faint">
        {label}
      </legend>
      <div className="flex flex-wrap gap-1.5">{children}</div>
    </fieldset>
  );
}

export function FilterChip({ active, onClick, children, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`rounded-full border px-2.5 py-1 text-xs transition-colors ${
        active
          ? 'border-accent bg-accent text-white'
          : 'border-rule-strong bg-paper-raised text-ink-muted hover:border-ink-faint hover:text-ink'
      } ${className}`}
    >
      {children}
    </button>
  );
}
